import React, { useContext } from 'react';

import { toTitle } from '../../base2/utils';
import { PersonContext, PersonProvider } from '../../context';

import { ValueDisplay } from './value-display';

interface Beneficiary {
  beneficiaryId: string;
  firstName: string;
  lastName: string;
  contactEmail: string;
  contactPhone: string;
}

interface BeneficiariesProps {
  beneficiaries: Beneficiary[];
}

export function Beneficiaries({ beneficiaries }: BeneficiariesProps) {
  console.log('Beneficiaries', beneficiaries);
  return (
    <div className="beneficiaries">
      {beneficiaries.map((beneficiary, index) => (
        <PersonProvider key={beneficiary.beneficiaryId} id={beneficiary.beneficiaryId}>
          <Beneficiary key={index} />
        </PersonProvider>
      ))}
    </div>
  );
}

export function Beneficiary() {
  const { person: beneficiary } = useContext(PersonContext);
  
  return (
    <dl className="beneficiary-detail">
      <div className="beneficiary-header">
        <dd className="beneficiary-name">{toTitle([ beneficiary.firstName, beneficiary.lastName ].filter(Boolean).join(' '))}</dd>
      </div>
      <div className="value-display-container">
        <ValueDisplay label="Email" value={beneficiary.contactEmail} />
        <ValueDisplay label="Phone" value={beneficiary.contactPhone} />
      </div>
    </dl>
  );
}
